import { Country } from "../../../shared/interface/country.interface";
import { SecType } from "../../enums/payment-ach-sectypes.enum";
import { PaymentACH } from "../../interface/ach-payment/payment-ach.interface";
import { PaymentAchRequest, PersonalAch } from "../../interface/ach-payment/payment-achrequest.interface";
import { ValidateAchRequest } from "../../interface/ach-payment/validate-ach-request.interface";
import { Address } from "../../interface/address";
import { PaymentComponentSettings } from "./payment.model";
import { FormGroup } from '@angular/forms';
import { PaymentMethodTypes } from "../../enums/order-source-type";
import { PaymentProcessor } from "./payment-processor.enum";
import { PayvisionSavedCard } from "../../interface/payvision/payvision-saved-card.interface";
import { AddressInformation } from "../../interface/address-detail-info";
import { PersonalCheck } from "../../interface/eCheck/payment-echeckrequest.interface";
import { AccountType } from "../../enums/echeck-accounttypes.enum";


export class ACHComponentSettings extends PaymentComponentSettings {
    secTypes: SecType[]
    accountTypes:AccountType[];
    achSchemaUrl: string;
    paymentACHForm: FormGroup;
    isSaveAchForFuture: boolean;
    isPaymentWithSavedAch: boolean;
    isAchSubmitted: boolean;
    achErrorMessage: string;
    viewBillingAddress: boolean;
    shippingAsBilling: boolean;
    shippingAddress: Address;
    phoneNumberFormat: string;
    selectedCountry: Country;
    achRequest: PaymentAchRequest;
    selectedAch: PersonalAch;
    validatePersonalAchRequest: ValidateAchRequest;
    paymentAch: PaymentACH;
    savePersonalAchRequest: PersonalAch;
    paymentMethodTypes = PaymentMethodTypes;
    paymentMethodTypeForm: FormGroup;
    processorTypes = PaymentProcessor;
    isoTwoletterCountryCode: string;
    isAddNewCard = false;
    savedCards: PayvisionSavedCard[];
    cardTypeImage: string;
    memberId: string;
    storeId: number;
    isoCountryCode: string;
    currencyCode: string;
    languageCode:string;
    memberTypeId:number;
    payvisionFormLoaded:boolean;
    webOrderId:string;
    billingAddress: AddressInformation;
    savedEChecks: PersonalCheck[];
    numberDecimals: number;
    memberEmail: string;
    orderReferenceId:string;
    paymentUrl:string;
    orderTypeId?: number;
    savedAchs?: PersonalAch[];

}




// WEBPACK FOOTER //
// ./src/app/customerservice/models/payments/payment-ach.model.ts